import { render } from "./EditRenewalOffer.vue?vue&type=template&id=065b29f7&scoped=true"
import script from "./EditRenewalOffer.vue?vue&type=script&lang=js"
export * from "./EditRenewalOffer.vue?vue&type=script&lang=js"

import "./EditRenewalOffer.vue?vue&type=style&index=0&id=065b29f7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065b29f7"]])

export default __exports__